/**
 * Parser for Connect search input. Pure (no Convex imports): the server
 * applies it and the client renders the same filters as chips.
 *
 *   design review in:#launch from:@raj
 *   in:"#product launch"  from:"Raj Kumar"
 *
 * `in:` names a channel by slug (`#` optional), `from:` a person by name or
 * email (`@` optional). Quote a value to include spaces. The last filter of a
 * kind wins; everything else is the search text.
 */
export type ConnectSearchQuery = {
  text: string;
  channelSlug: string | null;
  fromName: string | null;
};

export const CONNECT_SEARCH_MAX_LENGTH = 200;

const FILTER = /(^|\s)(in|from):(?:"([^"]*)"|(\S*))/gi;

/** Mirrors `normalizeSlug` (channel creation) so `in:` matches stored slugs. */
export function normalizeChannelSlug(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/^#/, '')
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function parseConnectSearchQuery(raw: string): ConnectSearchQuery {
  let channelSlug: string | null = null;
  let fromName: string | null = null;
  const text = raw.replace(
    FILTER,
    (_match, lead: string, key: string, quoted?: string, bare?: string) => {
      const value = (quoted ?? bare ?? '').trim();
      if (key.toLowerCase() === 'in') {
        const slug = normalizeChannelSlug(value);
        channelSlug = slug || null;
      } else {
        const name = value.replace(/^@/, '').trim();
        fromName = name || null;
      }
      return lead;
    }
  );
  return {
    text: text.replace(/\s+/g, ' ').trim(),
    channelSlug,
    fromName,
  };
}
